import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

const UEFBase = ({ platformUrl }) => {
    // Extract search parameters from the URL
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const userUuid = queryParams.get("uuid");
    const accessToken = queryParams.get("token");
    const encodedState = queryParams.get("state");

    useEffect(() => {
        // Get the current location
        const currentLocation = window.location.origin; // Gets the protocol, hostname, and port (if any)

        localStorage.setItem("platformUrl", platformUrl);
        localStorage.setItem("token", accessToken);
        localStorage.setItem("uuid", userUuid);
        localStorage.setItem("baseNavUrl", `${currentLocation}?token=${accessToken}&uuid=${userUuid}&route=UEFBaseNav&state=${encodedState}`);
        localStorage.setItem("courseDetailsUrl", `${currentLocation}?token=${accessToken}&uuid=${userUuid}&route=UEFCourseDetails&state=${encodedState}`);

        // Create a script element
        const script = document.createElement("script");

        // Set the script attributes
        script.src = "uef_base.js"; // Replace with the correct path to uef_base.js
        script.type = "text/javascript";
        script.async = true;

        // Append the script to the document body
        document.body.appendChild(script);

        // Cleanup function to remove the script when the component unmounts
        return () => {
            document.body.removeChild(script);
        };
    }, []);

    return (
        <div>
            <h1>UEF Demo</h1>
            <p>The <code>uef_demo.js</code> file is now available to the browser.</p>
        </div>
    );
};

export default UEFBase;
